import * as React from "react";

import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  TextField,
} from "@mui/material";
import AuthService from "../../Components/auth/AuthService";
import Autocomplete from "@mui/material/Autocomplete";
import { Box } from "@mui/system";
import Message from "../../Components/common/Message";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import {
  useLoadingDispatch,
  showLoading,
  hideLoading,
} from "../../context/loadingContext";
import CloseIcon from '@mui/icons-material/Close';

import moment from "moment";
import { Col, Row, Table, Tooltip, Button as AntButton, Tag, message, Popconfirm } from "antd";
import { CheckCircleFilled, CheckCircleOutlined, CloseCircleOutlined, DeleteFilled, EditFilled, ExclamationCircleOutlined, HistoryOutlined, PlusOutlined, PushpinOutlined, MailOutlined, TagsOutlined, NumberOutlined, ColumnHeightOutlined, PoundCircleFilled, CodeOutlined, PicCenterOutlined, ProductOutlined } from "@ant-design/icons";
import HelperReminderHistoryModal from "../../Components/Modals/HelperReminderHistoryModal";
import AddHelperReminderModal from "../../Components/Modals/AddHelperReminderModal";
import EditHelperReminderModal from "../../Components/Modals/EditHelperReminderModal";
import CompleteHelperReminderModal from "../../Components/Modals/CompleteHelperReminderModal";
import { availableDays, HelperReminderTasks } from "../../Components/common/Constants";
import { showMessage } from "../../Components/Utils/message";
import dayjs from "dayjs";
import FormGrid from "../../Components/common/FormGrid";
import InputBox from "../../Components/common/InputBox";
import { decodeId } from "../../Components/common/CommonFun";

const Auth = new AuthService();

export default function Helper(props) {
  const navigate = useNavigate();
  const params = useParams();
  const decodedID = decodeId(params?.id)
  var layoutDispatch = useLoadingDispatch();
  const [id, setId] = React.useState(decodedID ? decodedID : 0);

  const [allReminders, setAllReminders] = React.useState([]);
  const [allHelpers, setAllHelpers] = React.useState([]);
  const [historyRecord, setHistoryRecord] = React.useState([]);
  const [selectedRecord, setSelectedRecord] = React.useState("");

  const [reminderPage, setReminderPage] = React.useState(1);
  const [reminderPageChange, setReminderPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPagesReminder, setTotalPagesReminder] = React.useState(0);

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [isCompleteModalOpen, setIsCompleteModalOpen] = React.useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = React.useState(false);

  const [helperDetails, setHelperDetails] = React.useState({
    pin: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    daily_wage: ''
  })

  const [helperDetailsError, setHelperDetailsError] = React.useState({
    pin: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    daily_wage: ''
  });

  const [workDetails, setWorkDetails] = React.useState({
    workDays: [],
    offDays: [],
  });

  const helperDetailsItem = [
    {
      label: "Pin",
      value: helperDetails?.pin,
      onChange: (val) => {
        setHelperDetails({ ...helperDetails, pin: val });
        const errorMsg = validateString(val, 'Pin');
        setHelperDetailsError({ ...helperDetailsError, pin: errorMsg });
      },
      readOnly: false,
      icon: <CodeOutlined />,
      type: 'text',
      status: helperDetailsError.pin ? "error" : ""
    },
    {
      label: "First Name",
      value: helperDetails?.first_name,
      onChange: (val) => {
        setHelperDetails({ ...helperDetails, first_name: val });
        const errorMsg = validateString(val, 'First Name');
        setHelperDetailsError({ ...helperDetailsError, first_name: errorMsg });
      },
      icon: <TagsOutlined style={{ color: "#1677ff" }} />,
      readOnly: false,
      type: 'text',
      status: helperDetailsError.first_name ? "error" : ""

    },
    {
      label: "Last Name",
      value: helperDetails?.last_name,
      onChange: (val) => {
        setHelperDetails({ ...helperDetails, last_name: val })
        const errorMsg = validateString(val, 'Last Name');
        setHelperDetailsError({ ...helperDetailsError, last_name: errorMsg });
      },
      icon: <TagsOutlined style={{ color: "#1677ff" }} />,
      readOnly: false,
      type: 'text',
      status: helperDetailsError.last_name ? "error" : ""

    },

    {
      label: "Email",
      value: helperDetails?.email,
      onChange: (val) => {
        setHelperDetails({ ...helperDetails, email: val })
        const errorMsg = validateEmail(val);
        setHelperDetailsError({ ...helperDetailsError, email: errorMsg });
      },
      readOnly: false,
      icon: <MailOutlined style={{ color: "#52c41a" }} />,
      type: 'text',
      status: helperDetailsError.email ? "error" : ""
    },
    {
      label: "Phone Number",
      value: helperDetails?.phone,
      onChange: (val) => {
        setHelperDetails({ ...helperDetails, phone: val })
        const errorMsg = validatePhone(val);
        setHelperDetailsError({ ...helperDetailsError, phone: errorMsg });
      },
      readOnly: false,
      icon: <NumberOutlined style={{ color: "#52c41a" }} />,
      type: 'text',
      status: helperDetailsError.phone ? "error" : ""
    },
    {
      label: "Daily Wage (£)",
      value: helperDetails?.daily_wage,
      onChange: (val) => {
        setHelperDetails({ ...helperDetails, daily_wage: val })
        const errorMsg = validateString(val, 'Daily wage');
        setHelperDetailsError({ ...helperDetailsError, daily_wage: errorMsg });
      },
      readOnly: false,
      icon: <PoundCircleFilled style={{ color: "#52c41a" }} />,
      type: 'text',
      status: helperDetailsError.daily_wage ? "error" : ""
    },

  ]

  const workDayItem = {
    label: "Avaiable Days",
    value: workDetails?.workDays || [],
    options: availableDays,
    onChange: (values) => {
      const conflict = values.find((day) => workDetails?.offDays?.includes(day));
      if (conflict) {
        const conflictTitle =
          availableDays.find((d) => d.id === conflict)?.title || "This day"
        showMessage('error', `${conflictTitle} is already selected as an Off Day`);
        return;
      }
      setWorkDetails({ ...workDetails, workDays: values })
    },
    icon: <ProductOutlined style={{ color: "#1677ff" }} />,
    readOnly: false,
    type: 'select-multiple',
    data: 'constants',
  }

  const OffDayItem = {
    label: "Off Days",
    value: workDetails?.offDays || [],
    options: availableDays,
    onChange: (values) => {
      const conflict = values.find((day) => workDetails?.workDays?.includes(day));
      if (conflict) {
        const conflictTitle =
          availableDays.find((d) => d.id === conflict)?.title || "This day";
        showMessage('error', `${conflictTitle} is already selected as an Available Day`);
        return;
      }
      setWorkDetails({ ...workDetails, offDays: values });
    },
    icon: <ProductOutlined style={{ color: "#1677ff" }} />,
    readOnly: false,
    type: 'select-multiple',
    data: 'constants',
  }

  const getHelperData = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.post(`/helper/warehouse-helpers`)
      if (res.ack) {
        setAllHelpers(res.warehouse_helpers);
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  const getHistory = async (data) => {
    const DataToSend = {
      warehouse_helper_id: data?.helper_id,
      type: data?.type
    }
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch("/warehouse-helper-reminder/warehouse-helper-reminders-history", {
        method: "POST",
        body: JSON.stringify(DataToSend),
      })

      if (res?.ack) {
        console.log('res', res);
        if (res?.reminders.length > 0) {
          setHistoryRecord(res?.reminders)
          setIsHistoryModalOpen(true)
        } else {
          message?.info('No related history found')
        }
      } else {
        showMessage('error', res?.message)
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const getData = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/helper/warehouse-helper?id=${id}`)
      if (res.ack) {
        setHelperDetails({
          ...helperDetails,
          pin: res.warehouse_helper.pin,
          first_name: res.warehouse_helper.first_name,
          last_name: res.warehouse_helper.last_name,
          email: res.warehouse_helper.email,
          phone: res.warehouse_helper.phone,
          daily_wage: res.warehouse_helper.daily_wage
        })

        const workDays = res.selected_days?.map((d) => d.day);
        const offDays = res.selected_off_days?.map((d) => d.day);
        setWorkDetails({ ...workDetails, workDays: workDays, offDays: offDays })

      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch)
    }
  }


  React.useEffect(() => {
    if (id > 0) {
      getData()
      getHelperData()
    }
  }, []);

  const onClickCancel = () => {
    navigate("/helpers");
  };

  const validateForm = () => {
    const errors = {
      pin: helperDetails.pin ? "" : "Pin is required",
      first_name: helperDetails.first_name ? "" : "First name is required",
      last_name: helperDetails.last_name ? "" : "Last name is required",
      email: validateEmail(helperDetails.email),
      phone: validatePhone(helperDetails.phone),
      daily_wage: helperDetails.daily_wage ? "" : "Daily wage is required",
    };

    setHelperDetailsError(errors);

    for (const field of ["pin", "first_name", "last_name", "email", "phone", "daily_wage"]) {
      if (errors[field]) {
        showMessage('error', errors[field]);
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    const workDays = availableDays.filter((d) =>
      workDetails?.workDays?.includes(d.id)
    );

    const offDays = availableDays.filter((d) =>
      workDetails?.offDays?.includes(d.id)
    );

    const isUpdate = id > 0;
    const payload = {
      first_name: helperDetails?.first_name,
      last_name: helperDetails?.last_name,
      phone: helperDetails?.phone,
      email: helperDetails?.email,
      daily_wage: helperDetails?.daily_wage,
      pin: helperDetails?.pin,
      selected_days: workDays,
      selected_off_days: offDays,
      ...(isUpdate && { id }),
    };
    try {
      showLoading(layoutDispatch);
      const url = "/helper/warehouse-helper";
      const method = isUpdate ? "PUT" : "POST";

      const res = await Auth.fetch(url, {
        method,
        body: JSON.stringify(payload),
      });

      if (res?.ack) {
        showMessage('success', res?.message)
        setTimeout(() => navigate("/helpers"), 1000);
      } else {
        showMessage('error', res?.message)
      }
    } catch (err) {
      showMessage('error', 'something went wrong')
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const getStatusInfo = (date, thresholdDays) => {
    const daysDifference = date.diff(moment(), "days");

    if (daysDifference < 0) {
      return {
        color: "#ff002a",
        text: "Overdue",
        icon: <CloseCircleOutlined />,
      };
    } else if (daysDifference == thresholdDays || (daysDifference < thresholdDays && daysDifference > 0) || daysDifference === 0) {
      return {
        color: "#ec942c",
        text: "Due Soon",
        icon: <ExclamationCircleOutlined />,
      };
    } else if (daysDifference > thresholdDays) {
      return {
        color: "#339900",
        text: "Upcoming",
        icon: <CheckCircleOutlined />,
      };
    }
  }

  const reminderColumns = [


    {
      title: 'Next Due',
      render: (record) => {
        return (
          <>
            <span>{dayjs(record?.due_date).format("DD-MM-YYYY")}</span>
          </>
        )

      }

    },
    {
      align: "center",
      title: "Status",
      render: ({ due_date, type }) => {
        const serviceObject = HelperReminderTasks.find((obj) => obj.id === type);
        const info = getStatusInfo(moment(due_date, "YYYY-MM-DD"), serviceObject?.thresholdDays);
        return (
          <Tag color={info?.color} icon={info?.icon} style={{ marginLeft: '4px' }}>
            {info?.text}
          </Tag>
        );
      },
    },
    {
      align: "center",
      title: "Task",
      render: (record) => {
        const info = HelperReminderTasks.find((obj) => obj.id === record?.type);
        return (
          <>
            <span>{info?.title || ""}</span><br />
            <span style={{ fontSize: '10px', color: 'darkgrey' }}>{info?.message}</span>
          </>
        );
      },
    },
    {
      align: "center",
      title: "Last Completed",
      render: (record) => {
        return (
          <>
            <span>{record.last_completed ? dayjs(record.last_completed).format("DD-MM-YYYY") : null}</span>
          </>

        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "right",
      dataIndex: "",
      render(record) {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <Tooltip title="Resolve">
              <CheckCircleFilled
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                  marginRight: "5px",
                  color: "green",
                }}
                onClick={() => {
                  setSelectedRecord(record)
                  setIsCompleteModalOpen(true)
                }}
              />
            </Tooltip>
            {
              record?.last_completed && (
                <Tooltip title="History">
                  <HistoryOutlined
                    style={{
                      fontSize: "25px",
                      cursor: "pointer",
                      marginRight: "5px",
                      // color: "green",
                    }}
                    onClick={() => {
                      getHistory(record)
                    }}
                  />
                </Tooltip>
              )
            }

            <Tooltip title="Edit">
              <EditFilled
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                  marginRight: "5px",
                  color: "#006cb8",
                }}
                onClick={() => {
                  setSelectedRecord(record)
                  setIsEditModalOpen(true)
                }}
              />
            </Tooltip>
            {
              !record?.last_completed && (
                <Tooltip title="Delete">
                  <Popconfirm
                    title="Delete Record"
                    description="Are you sure you want to delete this record?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => handleDelete(record.id)}
                    placement="topLeft"
                    okButtonProps={{ style: { height: "40px", width: '80px', fontSize: '16px' } }}
                    cancelButtonProps={{ style: { height: "40px", width: '80px', fontSize: '16px' } }}
                  >
                    <DeleteFilled
                      style={{ fontSize: "25px", cursor: "pointer", color: "#cd1437" }}
                    />
                  </Popconfirm>
                </Tooltip>
              )
            }


          </div>
        );
      },
    },
  ];

  const handleDelete = async (recordID) => {
    showLoading(layoutDispatch)
    const params = {
      method: "DELETE",
      body: JSON.stringify({
        id: recordID,
      }),
    };
    try {
      const res = await Auth.fetch('/warehouse-helper-reminder/reminder-warehouse-helper', params)
      if (res?.ack) {
        showMessage('success', res.message)
        getReminder()
      } else {
        showMessage('error', res.message)
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const getReminder = async () => {
    const dataToSend = {
      warehouse_helper_id: Number(id),
    }
    if (reminderPage && reminderPageChange) dataToSend.page = reminderPage;
    showLoading(layoutDispatch);
    try {
      const reminderRes = await Auth.fetch("/warehouse-helper-reminder/reminders-warehouse-helper", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      })

      if (reminderRes?.ack) {
        setAllReminders(reminderRes?.reminders);
        setTotalPagesReminder(Math.ceil(reminderRes?.total_count / limit));
      } else {
        setAllReminders([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const handleReminderPageChange = (event, value) => {
    setReminderPage(value);
    setReminderPageChange(true)
  };

  React.useEffect(() => {
    if(id > 0) getReminder()
  }, [reminderPage]);


  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      return "Email is required";
    } else if (!emailRegex.test(value)) {
      return "Invalid email format";
    }
    return "";
  };

  const validatePhone = (value) => {
    const phoneRegex = /^[0-9]{10,15}$/;
    if (!value) {
      return "Phone number is required";
    } else if (!phoneRegex.test(value)) {
      return "Invalid phone number";
    }
    return "";
  };

  const validateString = (value, fieldName) => {
    if (!value || value.trim() === "") {
      return `${fieldName} is required`;
    }
    return "";
  };

  return (
    <>
      <div>
        <div className="details-box" style={{ marginTop: '15px' }}>
          <span className="detail-box-heading">Helper Details</span>
          <FormGrid formItems={helperDetailsItem} />
          <div className="detail-box" style={{ marginTop: '15px' }}>
            <span className="detail-box-heading">Work Days Details</span>
            <Row>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <InputBox inputItem={workDayItem} inputType='select' />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <InputBox inputItem={OffDayItem} inputType='select' />
              </Col>
            </Row>
          </div>
          <div style={{ display: "flex", justifyContent: 'end', marginTop: '15px', gap: 5 }}>
            <AntButton onClick={onClickCancel}>
              Cancel
            </AntButton>
            <AntButton type="primary" onClick={handleSubmit}>
              Save
            </AntButton>
          </div>
          {
            id > 0 && (
              <>
                <div className="detail-box" style={{ marginTop: '30px' }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                    <span className="detail-box-heading">
                      Helper Reminders
                    </span>
                    <AntButton onClick={() => {
                      setIsModalOpen(true)
                    }} type="primary" icon={<PlusOutlined />}>Add Helper Reminder</AntButton>
                  </div>

                  <Table dataSource={allReminders} columns={reminderColumns} style={{ marginTop: "4px" }} pagination={false} rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")} scroll={{ x: 'max-content' }} />
                  <div style={{ display: 'flex', justifyContent: "end", marginTop: "10px" }}>
                    <Pagination
                      page={reminderPage}
                      count={totalPagesReminder}
                      variant="outlined"
                      color="primary"
                      onChange={handleReminderPageChange}
                    />
                  </div>
                </div>
              </>
            )
          }
        </div>
      </div>
      <HelperReminderHistoryModal isModalOpen={isHistoryModalOpen} setIsModalOpen={setIsHistoryModalOpen} allHelpers={allHelpers} history={historyRecord} setHistory={setHistoryRecord} />
      <AddHelperReminderModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} allHelpers={allHelpers} searchFunction={getReminder} newRecord={id} />
      <EditHelperReminderModal isModalOpen={isEditModalOpen} setIsModalOpen={setIsEditModalOpen} allHelpers={allHelpers} selectedRecord={selectedRecord} setSelectedRecord={setSelectedRecord} searchFunction={getReminder} />
      <CompleteHelperReminderModal isModalOpen={isCompleteModalOpen} setIsModalOpen={setIsCompleteModalOpen} selectedRecord={selectedRecord} searchFunction={getReminder} allHelpers={allHelpers} />
    </>
  );
}
